import { render, staticRenderFns } from "./CommodityUnloadDefaults.vue?vue&type=template&id=dd4069ce"
import script from "./CommodityUnloadDefaults.vue?vue&type=script&lang=ts"
export * from "./CommodityUnloadDefaults.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports